module.exports = __webpack_public_path__ + "static/img/chrr-5-star-hr-consultant-2021.0019e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/chrr-5-star-hr-consultant-2021.png
// module id = ZZ1Q
// module chunks = 0